/* bristm-ai — section script (loaded only where the section renders) */
(function () {
  function sync(section) {
    var open = section.querySelector('[data-b-acc-item].is-open');
    var key = open ? open.getAttribute('data-b-ai-key') || 'default' : 'default';
    var imgs = section.querySelectorAll('[data-b-ai-img]');
    var found = false;
    imgs.forEach(function (img) {
      if (img.getAttribute('data-b-ai-img') === key) found = true;
    });
    if (!found) key = 'default';
    imgs.forEach(function (img) {
      img.classList.toggle('is-active', img.getAttribute('data-b-ai-img') === key);
    });
  }

  function initAi(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var sections = root.matches && root.matches('[data-b-ai]') ? [root] : root.querySelectorAll('[data-b-ai]');
    Array.prototype.forEach.call(sections, function (section) {
      if (section.dataset.bAiBound) return;
      section.dataset.bAiBound = '1';
      sync(section);
      if (!('MutationObserver' in window)) return;
      var mo = new MutationObserver(function () {
        sync(section);
      });
      section.querySelectorAll('[data-b-acc-item]').forEach(function (item) {
        mo.observe(item, { attributes: true, attributeFilter: ['class'] });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAi(document);
    });
  } else {
    initAi(document);
  }
  document.addEventListener('shopify:section:load', function (e) {
    initAi(e.target);
  });

  /* Theme editor: open the selected block's row */
  document.addEventListener('shopify:block:select', function (e) {
    var item = e.target;
    if (!item || !item.matches || !item.matches('.b-ai__item') || item.classList.contains('is-open')) return;
    var trigger = item.querySelector('[data-b-acc-trigger]');
    if (trigger) trigger.click();
  });
})();
